export default __webpack_public_path__ + "static/media/img2.07820ec4.webp";